import React from 'react';
function Icon(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 -960 960 960">
      <path fill={props.fill || '#1D252D'} d="M382-253.847L168.616-467.231l42.769-42.768L382-339.384l366.615-366.615 42.769 42.768L382-253.847z"></path>
    </svg>;
}
export default Icon;